import { create } from 'zustand';

import { registerModalOccupant } from '@/shared/lib/modal';

type TeamspaceWelcomeModalState = {
  isNewUser: boolean;
  showTooltip: boolean;
  spaceId: null | string;
  reset: () => void;
  setSpaceId: (value: null | string) => void;
};

export const useTeamspaceWelcomeModal = create<TeamspaceWelcomeModalState>((set) => ({
  isNewUser: false,
  showTooltip: false,
  spaceId: null,
  reset: () => set({ isNewUser: true, showTooltip: true, spaceId: null }),
  setSpaceId: (value) => set({ isNewUser: true, spaceId: value }),
}));

registerModalOccupant({
  subscribe: (listener) =>
    useTeamspaceWelcomeModal.subscribe((state, previous) =>
      listener({ isOpen: state.spaceId !== null }, { isOpen: previous.spaceId !== null }),
    ),
  getState: () => {
    const { spaceId, reset } = useTeamspaceWelcomeModal.getState();

    return { close: reset, isOpen: spaceId !== null };
  },
});
